import { Icon } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Table } from '@/components_deprecated'
import type { UserEquipmentTypeForSettings } from './types'

interface UserEquipmentTypeSettingsTableProps {
  editableTypes: UserEquipmentTypeForSettings[]
  onEditClick?: (type: UserEquipmentTypeForSettings) => void
  onDelete: (type: UserEquipmentTypeForSettings) => void
}

export const UserEquipmentTypeSettingsTable: React.FC<
  UserEquipmentTypeSettingsTableProps
> = ({ editableTypes, onEditClick, onDelete }) => {
  const translations = useTranslate({
    name: 'common.name',
    description: 'common.description',
  })

  return (
    <Table
      noShadow
      noBorders
      noHeaderMargin
      noRowMargin
      rowHoverColor="secondary"
    >
      <thead>
        <tr>
          <th>{translations.name}</th>
          <th>{translations.description}</th>
          <th></th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        {editableTypes.map(type => (
          <tr key={type.id}>
            <td>{type.name}</td>
            <td>{type.description}</td>

            <td width="1px">
              {onEditClick && type.editable && (
                <Icon
                  icon="edit"
                  cursor="pointer"
                  color="gray6"
                  hoverColor="secondary"
                  onClick={() => onEditClick(type)}
                />
              )}
            </td>

            <td width="1px">
              {type.editable && (
                <Icon
                  icon="times"
                  cursor="pointer"
                  color="gray6"
                  hoverColor="red"
                  onClick={() => onDelete(type)}
                />
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
